import gql from 'graphql-tag';

/**
 * Mutation to revert all customizations on an inspection template (building fork).
 */
export const revertAllTemplateCustomizationsMutation = gql`
  mutation RevertAllTemplateCustomizations($input: RevertAllTemplateCustomizationsInput!) {
    revertAllTemplateCustomizations(input: $input) {
      success
      newVersion
    }
  }
`;
